import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Invoices() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Invoices'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
